import * as React from "react";
import { cn } from "../../utils/cn";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn("form-control", className)}
      {...props}
    />
  );
});

Input.displayName = "Input";

export { Input };